module.exports = __webpack_public_path__ + "static/media/bank-card.a459065a.svg";